import React from "react";
import i18n from "locales/i18n";

/**
 * Represents a navigation item with an icon, label, and route.
 * @typedef {Object} NavItem
 * @property {string} icon - The CSS class for the icon.
 * @property {string[] | JSX.Element[]} label - The translated label using i18n, can be an array or JSX element.
 * @property {string} [to] - The target route for the navigation item (optional if content is present).
 * @property {NavItem[]} [content] - Optional nested navigation items.
 * @type {NavItem[]}
 */
export let DashboardNav = [
  {
    icon: "pe-7s-home",
    labelKey: "startup",
    to: "/dashboard",
  },
];

export let CreateRecordNav = [
  {
    icon: "pe-7s-pen",
    labelKey: "recordData.heading",
    to: "/record/list/forms",
  },
];

export let ConsultRecordNav = [
  {
    icon: "pe-7s-search",
    labelKey: "dashboard.label7",
    content: [
      {
        labelKey: "recordList1",
        to: "/record/list/form",
      },
    ],
  },
];

export let ConsultRecordNavTrdExplorer = [
  {
    icon: "pe-7s-search",
    labelKey: "dashboard.label7",
    content: [
      {
        labelKey: "recordList1",
        to: "/record/list/form",
      },
      {
        labelKey: "navItems.aplication.ConsultTRD",
        to: "/trd/expedients/consultation",
      },
    ],
  },
];

export let TaskBoxNav = [
  {
    icon: "pe-7s-drawer",
    labelKey: "taskBox",
    to: "/taskBox",
  },
];

export let ReportsNav = [
  {
    icon: "pe-7s-news-paper",
    labelKey: "info.SignatureNav",
    content: [
      {
        labelKey: "info.SignatureNav2",
        to: "/reports/signatures",
      },
    ],
  },
];

export let ProcessManagementNav = [
  {
    icon: "pe-7s-network",
    labelKey: "processManagement.Header",
    to: "/process/management",
  },
];

export let TrashNav = [
  {
    icon: "pe-7s-trash",
    labelKey: "trash.label1",
    to: "/trash",
  },
];

export let DataExportNav = [
  {
    icon: "pe-7s-download",
    labelKey: "export.records.nav.title",
    content: [
      {
        labelKey: "export.records.nav",
        to: "/export-data",
      },
    ],
  },
];

export let ParameterNav = [
  {
    icon: "pe-7s-config",
    label: () => (
      <div>
        {i18n.t("navItems.aplication.Parameters")}
        {"  "}
        <span className="badge badge-success badge-small"> {i18n.t("dashboard.label6")}</span>
      </div>
    ),
    content: [
      {
        labelKey: "navItems.aplication.TrdOption1",
        to: "/trd",
      },
      {
        labelKey: "navItems.aplication.documentalTypes",
        to: "/documentary-types/list",
      },
      {
        label: () => (
          <div>
            {i18n.t("navItems.aplication.Config")}
            {"  "}
            <span className="badge badge-success badge-small"> {i18n.t("dashboard.label6")}</span>
          </div>
        ),
        to: "/application/config/parameters",
      },
    ],
  },
];

export let ParameterDocumentaryTypeNav = [
  {
    icon: "pe-7s-config",
    label: () => (
      <div>
        {i18n.t("navItems.aplication.Parameters")}
        {"  "}
        <span className="badge badge-success badge-small"> {i18n.t("dashboard.label6")}</span>
      </div>
    ),
    content: [
      {
        labelKey: "navItems.aplication.documentalTypes",
        to: "/documentary-types/list",
      },
      {
        label: () => (
          <div>
            {i18n.t("navItems.aplication.Config")}
            {"  "}
            <span className="badge badge-success badge-small"> {i18n.t("dashboard.label6")}</span>
          </div>
        ),
        to: "/application/config/parameters",
      },
    ],
  },
];

export let FormsDesignerNav = [
  {
    icon: "pe-7s-note",
    labelKey: "form.designerItem1",
    content: [
      {
        labelKey: "form.designerItem2",
        to: "/formsdesigner/create",
      },
      {
        labelKey: "form.designerItem3",
        to: "/formsdesigner/list",
      },
    ],
  },
];

export let FormsDesignerNavConsult = [
  {
    icon: "pe-7s-note",
    labelKey: "form.designerItem1",
    content: [
      {
        labelKey: "form.designerItem3",
        to: "/formsdesigner/list",
      },
    ],
  },
];

export let ListDesignerNav = [
  {
    icon: "pe-7s-menu",
    labelKey: "list.designerItem1",
    content: [
      {
        labelKey: "list.designerItem2",
        to: "/formsdesigner/createlist",
      },
      {
        labelKey: "list.designerItem3",
        to: "/formsdesigner/consultlist",
      },
    ],
  },
];

export let AdminUsersThirdPartyAccounts = [
  {
    icon: "pe-7s-users",
    labelKey: "navItems.aplication.AdminUsers",
    content: [
      {
        labelKey: "navItems.aplication.AdminUsersOption5",
        to: "/user/Third-party-accounts",
      },
    ],
  },
];

export let AdminUsersAndRoleGroupsNav = [
  {
    icon: "pe-7s-users",
    labelKey: "navItems.aplication.AdminUsers",
    content: [
      {
        labelKey: "navItems.aplication.AdminUsersOption2",
        to: "/user/create",
      },
      {
        labelKey: "navItems.aplication.AdminUsersOption1",
        to: "/user/list",
      },
      {
        labelKey: "navItems.aplication.AdminUsersOption4",
        to: "/user/roles",
      },
      {
        labelKey: "create.work.group.nav",
        to: "/user/workgroup",
      },
      {
        labelKey: "navItems.aplication.AdminUsersOption5",
        to: "/user/Third-party-accounts",
      },
    ],
  },
];

export let AdminUsersAndRoleNav = [
  {
    icon: "pe-7s-users",
    labelKey: "navItems.aplication.AdminUsers",
    content: [
      {
        labelKey: "navItems.aplication.AdminUsersOption2",
        to: "/user/create",
      },
      {
        labelKey: "navItems.aplication.AdminUsersOption1",
        to: "/user/list",
      },
      {
        labelKey: "navItems.aplication.AdminUsersOption4",
        to: "/user/roles",
      },
      {
        labelKey: "navItems.aplication.AdminUsersOption5",
        to: "/user/Third-party-accounts",
      },
    ],
  },
];

export let AdminUsersGroupsNav = [
  {
    icon: "pe-7s-users",
    labelKey: "navItems.aplication.AdminUsers",
    content: [
      {
        labelKey: "navItems.aplication.AdminUsersOption2",
        to: "/user/create",
      },
      {
        labelKey: "navItems.aplication.AdminUsersOption1",
        to: "/user/list",
      },
      {
        labelKey: "create.work.group.nav",
        to: "/user/workgroup",
      },
      {
        labelKey: "navItems.aplication.AdminUsersOption5",
        to: "/user/Third-party-accounts",
      },
    ],
  },
];

export let AdminRoleGroupsNav = [
  {
    icon: "pe-7s-users",
    labelKey: "navItems.aplication.AdminUsers",
    content: [
      {
        labelKey: "navItems.aplication.AdminUsersOption4",
        to: "/user/roles",
      },
      {
        labelKey: "create.work.group.nav",
        to: "/user/workgroup",
      },
      {
        labelKey: "navItems.aplication.AdminUsersOption5",
        to: "/user/Third-party-accounts",
      },
    ],
  },
];

export let AdminUsersNav = [
  {
    icon: "pe-7s-users",
    labelKey: "navItems.aplication.AdminUsers",
    content: [
      {
        labelKey: "navItems.aplication.AdminUsersOption2",
        to: "/user/create",
      },
      {
        labelKey: "navItems.aplication.AdminUsersOption1",
        to: "/user/list",
      },
      {
        labelKey: "navItems.aplication.AdminUsersOption5",
        to: "/user/Third-party-accounts",
      },
    ],
  },
];

export let AdminUsersRoleNav = [
  {
    icon: "pe-7s-users",
    labelKey: "navItems.aplication.AdminUsers",
    content: [
      {
        labelKey: "navItems.aplication.AdminUsersOption4",
        to: "/user/roles",
      },
      {
        labelKey: "navItems.aplication.AdminUsersOption5",
        to: "/user/Third-party-accounts",
      },
    ],
  },
];

export let AdminUserWorkGroupNav = [
  {
    icon: "pe-7s-users",
    labelKey: "navItems.aplication.AdminUsers",
    content: [
      {
        labelKey: "create.work.group.nav",
        to: "/user/workgroup",
      },
      {
        labelKey: "navItems.aplication.AdminUsersOption5",
        to: "/user/Third-party-accounts",
      },
    ],
  },
];

export let WorkFlowDesignerNav = [
  {
    icon: "pe-7s-note",
    labelKey: "createWorflow.titleNav",
    content: [
      {
        labelKey: "createWorflow.SubtitleNav",
        to: "/WorkFlow",
      },
      {
        labelKey: "createWorflow.query",
        to: "/WorkFlow/list",
      },
    ],
  },
];

export let WorkFlowDesignerNavConsult = [
  {
    icon: "pe-7s-note",
    labelKey: "createWorflow.titleNav",
    content: [
      {
        labelKey: "createWorflow.query",
        to: "/WorkFlow/list",
      },
    ],
  },
];

export let DocumentTemplatesDesignerNav = [
  {
    icon: "pe-7s-display2",
    labelKey: "templatesDesigner.title",
    content: [
      {
        labelKey: "templatesDesigner.quey",
        to: "/templates/list",
      },
    ],
  },
];

export let MetricsNav = [
  {
    icon: "pe-7s-graph3",
    labelKey: "AuditLogs",
    content: [
      {
        labelKey: "metrics",
        to: "/metrics",
      },
      {
        labelKey: "AuditLogs.nav",
        to: "/audit/logs",
      },
    ],
  },
];

export let MetricsOnlyNav = [
  {
    icon: "pe-7s-graph3",
    labelKey: "AuditLogs",
    content: [
      {
        labelKey: "metrics",
        to: "/metrics",
      },
    ],
  },
];

export let MetricsLogsNav = [
  {
    icon: "pe-7s-graph3",
    labelKey: "AuditLogs",
    content: [
      {
        labelKey: "AuditLogs.nav",
        to: "/audit/logs",
      },
    ],
  },
];

export let IntegrationsNav = [
  {
    icon: "pe-7s-keypad",
    labelKey: "integrations.nav",
    to: "/integrations",
  },
];
